import styles from './JumpBackInToast.module.css';
import JumpBackInToastContent from './JumpBackInToastContent/JumpBackInToastContent';

const JumpBackInToast = () => {
  return (
    <div className={styles.container}>
      <JumpBackInToastContent />
    </div>
  );
};

export default JumpBackInToast;
